import { render, staticRenderFns } from "./MyCollections.vue?vue&type=template&id=c92f18f2&scoped=true&"
import script from "./MyCollections.vue?vue&type=script&lang=js&"
export * from "./MyCollections.vue?vue&type=script&lang=js&"
import style0 from "./MyCollections.vue?vue&type=style&index=0&id=c92f18f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92f18f2",
  null
  
)

export default component.exports